import {Grid} from '@material-ui/core';
import {SectionLabel} from 'Quoting/components/shared/SectionLabel';
import React from 'react';

export type ConditionalSection = {
  key: string;
  label: string;
  Component: React.FC;
  disabled?: boolean;
  isApplied?: boolean;
  hidden?: boolean;
  onToggleVisibility?: (visibility: boolean) => void;
};

export type QuoteFormConditionalSectionProps = {
  sections: ConditionalSection[];
};

export const QuoteFormConditionalSection = (props: QuoteFormConditionalSectionProps) => {
  return (
    <Grid container alignItems="center" spacing={1} style={{padding: '0 2rem'}}>
      {props.sections.map(
        ({Component, key, label, isApplied, disabled, hidden = false, onToggleVisibility}) =>
          !hidden && (
            <React.Fragment key={key}>
              <Grid item xs={12}>
                <SectionLabel
                  variant="label-with-checkbox"
                  header={label}
                  isChecked={isApplied ?? false}
                  disabled={disabled}
                  handleChange={value => onToggleVisibility?.(value)}
                />
              </Grid>
              <Grid item xs={12}>
                {isApplied && <Component />}
              </Grid>
            </React.Fragment>
          )
      )}
    </Grid>
  );
};

export type DualComponentConditionalSection = {
  key: string;
  label: string;
  PrimaryComponent: React.FC;
  SecondaryComponent: React.FC;
  disabled?: boolean;
  isApplied?: boolean;
  hidden?: boolean;
  onToggleVisibility?: (visibility: boolean) => void;
};

export type QuoteFormDualConditionalSectionProps = {
  sections: DualComponentConditionalSection[];
};

export const QuoteFormDualConditionalSection = (props: QuoteFormDualConditionalSectionProps) => {
  return (
    <Grid container alignItems="center" spacing={1} style={{padding: '0 2rem'}}>
      {props.sections.map(
        ({PrimaryComponent, SecondaryComponent, key, label, isApplied, disabled, hidden = false, onToggleVisibility}) =>
          !hidden && (
            <React.Fragment key={key}>
              <Grid item xs={12}>
                <SectionLabel
                  variant="label-with-checkbox"
                  header={label}
                  isChecked={isApplied ?? false}
                  disabled={disabled}
                  handleChange={value => onToggleVisibility?.(value)}
                />
              </Grid>
              <Grid item xs={6}>
                <PrimaryComponent />
              </Grid>
              <Grid item xs={6}>
                {isApplied && <SecondaryComponent/>}
              </Grid>
            </React.Fragment>
          )
      )}
    </Grid>
  );
};